import { useFormContext } from "react-hook-form";

const StreamData = () => {
  const { register } = useFormContext();

  return (
    <>
      <div className="flex gap-2">
        <div className="w-full">
        <h3 className="w-full text-justify text-sm text-gray-500 -mb-4 mt-3 capitalize">Total Earnings</h3>
          <input type="number" {...register("totalEarnings")} className="" placeholder="Total Earnings" />
        </div>
        <div className="w-full">
        <h3 className="w-full text-justify text-sm text-gray-500 -mb-4 mt-3 capitalize">Total Streamings</h3>
          <input type="number" {...register("totalStreams")} className="" placeholder="Total Streams" />
        </div>
      </div>
  
    <div className="border border-gray-200 px-6 py-1 my-2">
      <h3 className="text-left text-xl text-gray-500">Streams</h3>
      {["boomplay", "audioMack", "youtubeMusic", "spotify", "appleMusic", "amazonMusic", "tidal", "soundCloud"].map(
        (platform) => {
          let myPlatform = platform;
          if (myPlatform.includes("Music")) {
            myPlatform = myPlatform.replace(/(\S)(Music)/i, "$1 $2");
          }
          return (
            <div key={platform}>
              <h3 className="w-full text-justify text-sm text-gray-500 -mb-4 mt-3 capitalize">{myPlatform}</h3>
              <div className="flex gap-4">
                <input {...register(`streams.${platform}.earning`)} placeholder="Earnings" className="border p-2 w-[20%]" />
                <input {...register(`streams.${platform}.stream`)} placeholder="Streams" className="border p-2 w-[20%]" />
                <input {...register(`streams.${platform}.link`)} placeholder="Link" className="border p-2 w-[60%]" />
              </div>
            </div>
          );
        }
      )}
    </div>
    </>
  );
};

export default StreamData;
